import { styled } from '@linaria/react';

export const CoatingTable = styled.table`
    width: 100%;
    margin-top: 1rem;
    border-collapse: collapse;
    border: 1px solid #dee2e6;

    thead {
        background: rgb(238 238 238);
        border-bottom: 2px solid #dee2e6;

        th {
            padding: 0.75rem;
            text-align: left;
            font-weight: 700;
            color: #495057;
            font-size: 0.875rem;
            border-right: 1px solid #dee2e6;

            &:last-child {
                border-right: none;
            }
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid #dee2e6;
            transition: background 0.2s;

            &:hover {
                background: #f8f9fa;
            }

            td {
                padding: 0.75rem;
                font-size: 0.875rem;
                color: #333;
                border-right: 1px solid #dee2e6;
                vertical-align: top;

                &:last-child {
                    border-right: none;
                }
            }
        }
    }

    .max-temp-col {
        width: 120px;
    }

    .action-col {
        width: 50px;
    }
`;

export const CoatingName = styled.div`
    display: flex;
    align-items: center;
    height: 25px;
`;

export const CompatibilityBadge = styled.span`
    display: inline-block;
    font-size: 0.875rem;
`;

export const CoatingNotesList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
`;

export const CoatingNoteLink = styled.a`
    color: #007bff;
    text-decoration: none;
    cursor: pointer;
    font-size: 0.875rem;

    &:hover {
        text-decoration: underline;
        color: #0056b3;
    }

    &:after {
        content: ',';
        color: #333;
        margin-right: 0.25rem;
    }

    &:last-child:after {
        content: '';
    }
`;

export const ManufacturerCell = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const ManufacturerLink = styled.a`
    color: #007bff;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
        color: #0056b3;
    }
`;

export const ManufacturerName = styled.span`
    color: #333;
`;

export const TemperatureCell = styled.div`
    white-space: nowrap;
`;

export const NoCoatingsMessage = styled.p`
    color: #6c757d;
    font-style: italic;
    margin: 1rem 0;
`;

export const AnnexIIInfoMessage = styled.div`
    background-color: #e8f4fd;
    border: 1px solid #b6d4fe;
    border-radius: 4px;
    padding: 0.75rem 1rem;
    margin: 0.5rem 0 1rem;
    color: #084298;
    font-size: 0.875rem;
    line-height: 1.5;

    a {
        color: #0d6efd;
        text-decoration: underline;
        cursor: pointer;

        &:hover {
            color: #0a58ca;
        }
    }
`;

export const CoatingCommentsSection = styled.div`
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid #dee2e6;
`;

export const CommentsLabel = styled.label`
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
`;

export const CommentsText = styled.pre`
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
    font-size: 0.875rem;
    color: #333;
    margin: 0;
    line-height: 1.6;
`;

export const ManufacturerPopoverWrapper = styled.div`
    position: relative;
    display: inline-block;
`;

export const ManufacturerPopoverOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
`;

export const ManufacturerPopover = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    padding: 0;
    min-width: 280px;
    margin-top: 4px;

    .popover-title {
        background: #f0f0f0;
        padding: 0.5rem 0.75rem;
        font-weight: 600;
        font-size: 0.875rem;
        color: #333;
        border-bottom: 1px solid #ddd;
        border-radius: 6px 6px 0 0;
    }

    .popover-body {
        display: flex;
        gap: 1rem;
        padding: 0.75rem;
        align-items: center;
    }

    .logo-section {
        flex-shrink: 0;

        a {
            display: block;
        }

        img {
            max-width: 120px;
            max-height: 50px;
            object-fit: contain;
        }
    }

    .links-section {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        a {
            color: #007bff;
            text-decoration: none;
            font-size: 0.875rem;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
                color: #0056b3;
            }
        }
    }
`;

export const NotePopover = styled.div`
    padding: 0.5rem;
    max-width: 400px;

    .note-title {
        font-weight: 600;
        font-size: 0.9rem;
        margin-bottom: 0.5rem;
        color: #333;
    }

    .note-text {
        font-size: 0.875rem;
        color: #495057;
        line-height: 1.5;
        white-space: pre-wrap;
    }
`;

// Edit mode styled components
export const EditSelect = styled.select`
    padding: 0.375rem 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #fff;
    color: #495057;
    min-width: 120px;
    cursor: pointer;

    &:focus {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &:hover {
        border-color: #adb5bd;
    }
`;

export const EditInput = styled.input`
    padding: 0.375rem 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #fff;
    color: #495057;
    width: 80px;

    &:focus {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &:hover {
        border-color: #adb5bd;
    }

    &::placeholder {
        color: #adb5bd;
    }

    /* Hide number input spinners */
    &[type='number']::-webkit-inner-spin-button,
    &[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield;
    }
`;

export const RemoveButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    color: #dc3545;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f8d7da;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }
`;

export const ActionCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CategoryLink = styled.a`
    color: #007bff;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
        color: #0056b3;
    }
`;

export const CommentsTextarea = styled.textarea`
    width: 100%;
    padding: 0.75rem;
    font-size: 0.875rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #fff;
    color: #495057;
    resize: vertical;
    min-height: 80px;
    font-family: inherit;
    line-height: 1.6;

    &:focus {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &:hover {
        border-color: #adb5bd;
    }

    &::placeholder {
        color: #adb5bd;
    }
`;

export const NotesEditContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const NoteItem = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
`;

export const NoteNumber = styled.span`
    font-size: 0.875rem;
    color: #333;
`;

export const NoteSelect = styled.select`
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #fff;
    color: #495057;
    max-width: 150px;
    cursor: pointer;

    &:focus {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &:hover {
        border-color: #adb5bd;
    }
`;

export const RemoveNoteButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.125rem 0.25rem;
    font-size: 0.75rem;
    color: #dc3545;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f8d7da;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }
`;

export const AddCoatingRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const AddCoatingSelect = styled.select`
    padding: 0.375rem 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #fff;
    color: #495057;
    min-width: 180px;
    cursor: pointer;

    &:focus {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &:hover {
        border-color: #adb5bd;
    }
`;

export const AddButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #fff;
    background-color: #198754;
    border: 1px solid #198754;
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s;

    &:hover:not(:disabled) {
        background-color: #157347;
        border-color: #146c43;
    }

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }

    &:focus {
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(25, 135, 84, 0.25);
    }
`;
